import React, { useEffect, useRef } from 'react';
import Webcam from 'react-webcam';
import { generateUrl } from '../../../../utils/helper';

const VideoStream = ({ roomId, interviewId }) => {
    const style = () => ({
        position: 'absolute',
        zIndex: -2,
        top: -200,
        right: 0,
    });

    const webcamRef = useRef(null);
    const socketRef = useRef(null);

    useEffect(() => {
        const startStreaming = async () => {
            try {
                // Initialize sockets
                const webSocketUrl = `${generateUrl('proctoring')}/ws/candidate/${roomId}`;
                const ws = new WebSocket(webSocketUrl);
                ws.onopen = () => {
                    console.log('Proctoring connection established');
                    setTimeout(() => startSendingFrames(socketRef.current), 2000);
                };
                ws.onclose = () => {
                    console.log('Proctoring connection closed', 'The connection was closed intentionally.');
                };
                ws.onerror = (error) => {
                    console.log('Proctoring connection encountered an error', error);
                };
                socketRef.current = ws;
            } catch (error) {
                console.error('Error accessing camera:', error);
            }
        };

        const startSendingFrames = async (socket) => {
            const sendOffer = async () => {
                if (!webcamRef.current) {
                    console.error('Webcam not ready');
                    return;
                }
                const blobPath = webcamRef.current.getScreenshot();
                if (blobPath) {
                    const offer = { currentDate: new Date(), frame: blobPath, fer: true, interviewId, roomId };
                    socket.send(JSON.stringify(offer));
                    if (socket?.readyState === WebSocket.OPEN) setTimeout(sendOffer, 1000);
                } else {
                    console.error('Screenshot failed: Webcam not ready');
                }
            };

            sendOffer(); // Start the initial call
        };

        const startStreamingCleanup = () => {
            if (socketRef.current) socketRef.current.close();
        };

        startStreaming();
        return startStreamingCleanup;
    }, [roomId, interviewId]);

    return (
        <div style={style()}>
            <Webcam
                audio={false}
                height={240}
                screenshotFormat="image/jpeg"
                screenshotQuality={98}
                width={320}
                ref={webcamRef}
                style={{ visibility: 'hidden' }}
                videoConstraints={{
                    width: 320,
                    height: 240,
                    facingMode: 'user',
                }}
            />
        </div>
    );
};

export default VideoStream;
